// A2-581 screen map, lead 6 (verified 2026-11-02): a country form's links to a
// review card ("pick the right rate", held rows, invoiced VAT) carried no
// calculation, so the card opened on whatever calculation the workflow had
// loaded - another period's, or none. The link names the form's own
// calculation (?calc_id=, workflow/useUrlCalcOpen); the review page opens the
// card only on that calculation.
import { useParams } from "react-router-dom";

export const reviewCardHref = (flag, calcId) => (calcId
  ? `/workflow/review?calc_id=${encodeURIComponent(calcId)}&card=${encodeURIComponent(flag)}`
  : `/workflow/review?card=${encodeURIComponent(flag)}`);

export const useReviewCardHref = (flag) => {
  const { calcId } = useParams();
  return reviewCardHref(flag, calcId);
};
